const PAGE_LOADED_AT = Date.now();
const AUTH_ERROR_GRACE_MS = 1000;

export function isAuthHttpStatus(status: number): boolean {
  return status === 401 || status === 403;
}

/** Suppress auth error UI during the first second after page load (cookie/session race). */
export async function handleAuthHttpStatus(
  status: number,
  onReport: () => void
): Promise<void> {
  if (!isAuthHttpStatus(status)) return;

  const elapsed = Date.now() - PAGE_LOADED_AT;
  if (elapsed < AUTH_ERROR_GRACE_MS) {
    await new Promise((resolve) =>
      setTimeout(resolve, AUTH_ERROR_GRACE_MS - elapsed)
    );
    return;
  }

  onReport();
}
